import {Button, Grid, MenuItem} from "@mui/material";

import FormikInput from "../../components/Form/FormikInput";
import Form from "../../components/Templates/Form";
import useTenantCommunityInboxPostContainer from "../../containers/TenantCommunityInbox/useTenantCommunityInboxPostContainer";
import { useContent } from "../../content/useContent";
import {useParams} from "react-router-dom";
import {useRTL} from "../../hooks/useLanguage/useRTL";
import {IStatusCodes} from "../../api/tenantCommunityInboxPost";
import FormikSelect from "../../components/Form/FormikSelect";
import {translator} from "../../utils/translations/translator";
import {statusesAr} from "../../utils/translations";
import Info from "../../components/Info";
import ImageList from "../../components/ImageList";
import AlertDialog from "../../components/AlertDialog";
import FormikDateTimePicker from "../../components/Form/FormikDateTimePicker";

const AddTenantCommunityInboxPost = () => {
  const {
    pageLoading,
    tenantCommunityInboxPostFormik,
    loading,
    postImage,
    handleAttachment,
    handleOpenDeleteImage,
    handleDeleteImage,
    openDeleteDialog,
    setOpenDeleteDialog
  } = useTenantCommunityInboxPostContainer();
  const { isRTL } = useRTL();

  const { pages, general } = useContent();
  const { tenantCommunityInbox } = pages;

  return (
      <Form
          title={tenantCommunityInbox.tenantCommunityInboxPost}
          pageLoading={pageLoading}
          formik={tenantCommunityInboxPostFormik}
          submitLoading={loading}
          width="75%"
      >
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <FormikInput
                formik={tenantCommunityInboxPostFormik}
                name="title"
                label={tenantCommunityInbox.title}
            />
          </Grid>

          <Grid item xs={12}>
            <FormikInput
                formik={tenantCommunityInboxPostFormik}
                name="message"
                label={tenantCommunityInbox.message}
                multiline
                rows={3}
            />
          </Grid>

          <Grid item xs={12}>`
            <FormikDateTimePicker
                formik={tenantCommunityInboxPostFormik}
                name="publishedAt"
                label={tenantCommunityInbox.postDate}
            />
          </Grid>

          <Grid item xs={12}>
            <Info title={tenantCommunityInbox.attachments} />
            <ImageList images={postImage} handleAction={handleOpenDeleteImage} />

            <Button variant="contained" component="label" sx={{ my: 1 }}>
              {tenantCommunityInbox.chooseFile}
              <input
                  hidden
                  accept="image/*"
                  type="file"
                  key={postImage}
                  onChange={handleAttachment}
              />
            </Button>
          </Grid>
        </Grid>

        <AlertDialog
            open={openDeleteDialog}
            handleClose={() => setOpenDeleteDialog(false)}
            onAgree={handleDeleteImage}
            loading={loading}
            agreeText={general.delete}
            disagreeText={general.cancel}
            title={tenantCommunityInbox.sureDeleteImg}
        />
      </Form>
  );
};

export default AddTenantCommunityInboxPost;
